import serves from "@/http";
// import * as storage from "../storage";
import * as types from "./mutations-type";
export const ActionCadastro = ({dispatch},payload)=>{
    return serves.dstavulso.cadastra(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionLista = ({dispatch},payload)=>{
    return serves.dstavulso.lista(payload).then(res => {
        dispatch('ActionSetLista',res)
    }).catch(err => {
        dispatch('ActionSetLista',res)
    })
}
export const ActionPesquisa = ({dispatch},payload)=>{
    return serves.boletinstabela.pesquisa(payload).then(res => {
        dispatch('ActionSetBoletins',res)
    }).catch(err => {
        dispatch('ActionSetBoletins',res)
    })
}
export const ActionDeletar = ({dispatch},payload)=>{
    return serves.dstavulso.delete(payload).then(res => {
        console.log(res);
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',res)
    })
}
export const ActionDeletarCodigo = ({dispatch},payload)=>{
    return serves.dstavulso.deletecodigo(payload).then(res => {
        console.log(res);
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',res)
    })
}
export const ActionEditar = ({dispatch},payload)=>{
    return serves.dstavulso.editar(payload).then(res => {
        dispatch('ActionSetEditar',res)
    }).catch(err => {
        dispatch('ActionSetEditar',err)
    })
}
export const ActionUpdate = ({dispatch},payload)=>{
    return serves.dstavulso.update(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionNumero = ({dispatch},payload)=>{
    return serves.boletinstabela.numero(payload).then(res => {
        dispatch('ActionSetNumero',res)
    }).catch(err => {
        dispatch('ActionSetNumero',err)
    })
}
export const ActionSetLista = ({commit},payload) =>{
    commit(types.SET_LISTA,payload)
}
export const ActionSetMsg = ({commit},payload) =>{
    commit(types.SET_MSG,payload)
}
export const ActionSetEditar = ({commit},payload) =>{
    commit(types.SET_EDITAR,payload)
}
export const ActionSetBoletins = ({commit},payload) =>{
    commit(types.SET_BOLETINS,payload)
}
export const ActionSetNumero = ({commit},payload) =>{
    commit(types.SET_NUMERO,payload)
}
